// extracted by mini-css-extract-plugin
export default {"root":"_2RYwk","icon":"_2LoNR","title":"tF4Rv","subtitle":"hrC-7","button":"_1kT_i"};